export default "__VITE_ASSET__CfluxFda__"